import React from 'react';
import PropTypes from 'prop-types';
import TextFilter from 'components/input/TextInput/TextInput';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import EnabledFilter from 'components/form/filters/EnabledFilter';

const EmailComponent = <TextFilter
    label='resources.users.fields.email'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='email'
/>;

const LastNameComponent = <TextFilter
    label='resources.users.fields.lastname'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='last_name'
/>;

const UsersListFilters = (props) => {
    const filters = {
        basic: {
            last_name: {
                component: LastNameComponent,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            email: {
                component: EmailComponent,
                matchTypes: {
                    values: [
                        filterMatchTypes.contains,
                    ],
                },
            },
            is_enabled: {
                component: EnabledFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        filters={ filters }
        { ...props }
    />;
};

UsersListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default UsersListFilters;



// WEBPACK FOOTER //
// ./src/pages/users/list/UsersListFilters.js